import cx from 'classnames';
import React from 'react';
import './spec-course-lesson-view__section.scss';

interface Props {
    children: React.ReactNode | Array<React.ReactNode>;
    mix?: string;
}

export const SpecCourseLessonViewSection = React.forwardRef<HTMLDivElement, Props>(({ children, mix }, ref) => {
    return (
        <div className={cx('spec-course-lesson-view__section', mix)} ref={ref}>
            {children}
        </div>
    );
});
